export default class ApplyButton {
    constructor(element, parent) {
        this.parent = parent;
        this.element = element;
    }

    init() {
        this.registerEffects();
    }

    registerEffects() {
        this.element.addEventListener('click', (event) => {
            event.target.dispatchEvent(
                new CustomEvent('gg-filter-changed', {
                    bubbles: true,
                    detail: { filter: this.parent.filterArgs },
                })
            );
        });
    }
}
